/**
 * PWA install banner — shown when the app can be installed on the device.
 * Slides in from the bottom on mobile, shows a compact bar on desktop.
 */

import { useInstallPrompt } from '../hooks/use-install-prompt';

export function InstallBanner(): React.ReactElement | null {
  const { canInstall, promptInstall, dismiss } = useInstallPrompt();

  if (!canInstall) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-50 safe-area-pb animate-in slide-in-from-bottom duration-300">
      <div className="mx-auto max-w-lg p-3">
        <div className="flex items-center gap-3 rounded-xl bg-card border border-border shadow-lg px-4 py-3">
          <img src="/icon-192.png" alt="FrameIt" className="w-10 h-10 rounded-lg shrink-0" />
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium text-foreground truncate">Asenna FrameIt</p>
            <p className="text-xs text-muted-foreground">Lisää sovellus aloitusnäytölle</p>
          </div>
          <button
            onClick={dismiss}
            className="text-xs text-muted-foreground hover:text-foreground px-2 py-1 shrink-0"
          >
            Ei nyt
          </button>
          <button
            onClick={promptInstall}
            className="bg-primary text-primary-foreground text-sm font-medium px-4 py-2 rounded-lg hover:bg-primary/90 shrink-0"
          >
            Asenna
          </button>
        </div>
      </div>
    </div>
  );
}
